import { all, call, fork, put, takeLatest } from 'redux-saga/effects';
import {
  ADD_ADDRESS,
  FETCH_ADDRESSES,
  REMOVE_ADDRESS,
  MODIFY_ADDRESS,
} from 'store/actionTypes';
import {
  postAddress,
  getAddresses,
  deleteAddress,
  editAddress,
} from 'services';

import {
  addAddressSuccess,
  addAddressError,
  fetchAddressesSuccess,
  fetchAddressesError,
  removeAddressSuccess,
  removeAddressError,
  modifyAddressSuccess,
  modifyAddressError,
} from 'store/actions';

function* addAddressItem({ payload }) {
  try {
    const response = yield call(postAddress, payload);
    if (!response.message) {
      yield put(addAddressSuccess(response.data));
    } else {
      yield put(addAddressError(response.message));
    }
  } catch (error) {
    yield put(addAddressError(error));
  }
}

export function* watchAddAddress() {
  yield takeLatest(ADD_ADDRESS, addAddressItem);
}

function* fetchAddressItems() {
  try {
    const response = yield call(getAddresses);
    if (!response.message) {
      yield put(fetchAddressesSuccess(response.data));
    } else {
      yield put(fetchAddressesError(response.message));
    }
  } catch (error) {
    yield put(fetchAddressesError(error));
  }
}

export function* watchFetchAddresses() {
  yield takeLatest(FETCH_ADDRESSES, fetchAddressItems);
}

function* removeAddressItem({ payload }) {
  try {
    const response = yield call(deleteAddress, payload);
    if (!response.message) {
      yield put(removeAddressSuccess(response.data));
    } else {
      yield put(removeAddressError(response.message));
    }
  } catch (error) {
    yield put(removeAddressError(error));
  }
}

export function* watchRemoveAddress() {
  yield takeLatest(REMOVE_ADDRESS, removeAddressItem);
}

function* modifyAddressItem({ payload }) {
  try {
    const response = yield call(editAddress, payload);
    if (!response.message) {
      yield put(modifyAddressSuccess(response.data));
    } else {
      yield put(modifyAddressError(response.message));
    }
  } catch (error) {
    yield put(modifyAddressError(error));
  }
}

export function* watchModifyAddress() {
  yield takeLatest(MODIFY_ADDRESS, modifyAddressItem);
}

export default function* rootSaga() {
  yield all([
    fork(watchAddAddress),
    fork(watchFetchAddresses),
    fork(watchRemoveAddress),
    fork(watchModifyAddress),
  ]);
}
